import { ICity, ICoords } from '../components/types'
import { whereToBuy_wtb_nodes } from '../__generated__/whereToBuy'
import { getPropByCode } from './gql'

export const createCity = (node: whereToBuy_wtb_nodes): ICity => {
  const name = node.name
  const code = node.id
  const cityCoords = getPropByCode(node.propertyValues, 'UF_COORDINATES')
  const shops = []
  let coords: ICoords

  if (cityCoords) {
    const splitted = cityCoords.split(',')

    coords = { lat: splitted[0], lng: splitted[1] }
  }

  node.elements?.map((element) => {
    const coords = getPropByCode(element.propertyValues, 'COORDS').split(',')
    shops.push({
      name: element.name,
      code: element.id,
      address: getPropByCode(element.propertyValues, 'ADDRESS'),
      phone: getPropByCode(element.propertyValues, 'PHONE'),
      mail: getPropByCode(element.propertyValues, 'EMAIL'),
      site: getPropByCode(element.propertyValues, 'SITE'),
      coords: { lat: coords[0], lng: coords[1] },
    })
  })

  return {
    name,
    code,
    shops,
    coords,
  }
}
